import { Template } from '@typings/template';

interface Props {
  list: Omit<Template, 'index'>[];
  card: string;
  info: string;
  container: string;
}

function remToPx(rem: number) {
  const element = document.querySelector('html');
  const [fontSize] = element!.style.fontSize.split('px');
  return rem * Number(fontSize);
}
export default function refresh(props: Props) {
  const { list, card, info, container } = props;
  const cards = document.querySelectorAll(card) as NodeListOf<HTMLElement>;
  const infos = document.querySelectorAll(info) as NodeListOf<HTMLElement>;
  const containerDom = document.querySelector(container) as HTMLElement;
  const itemWidth = remToPx(3.34);
  const gap = 20;
  const arr: number[] = [];
  const columns = 2;
  cards.forEach((item, i) => {
    if (i < columns) {
      // 2- 确定第一行
      item.style.top = '0';
      if (i === 0) {
        item.style.left = '0';
      } else {
        item.style.right = '0';
      }
      const current = list[i];
      const height = (itemWidth / current.cover_width) * current.cover_height;
      console.log(height, infos[i].offsetHeight, gap);
      arr.push(height + infos[i].offsetHeight);
    } else {
      let minHeight = arr[0];
      let index = 0;
      for (let j = 0; j < arr.length; j++) {
        if (minHeight > arr[j]) {
          minHeight = arr[j];
          index = j;
        }
      }
      item.style.top = `${arr[index] + gap}px`;
      const left = cards[index].offsetLeft;
      if (left === 0) {
        item.style.left = '0';
      } else {
        item.style.right = '0';
      }
      // item.style.left = `${cards[index].offsetLeft}px`;
      const current = list[i];
      const height = (itemWidth / current.cover_width) * current.cover_height;
      arr[index] = arr[index] + height + infos[i].offsetHeight + gap;
    }
  });
  if (containerDom) {
    containerDom.style.height = `${Math.max.apply(null, arr)}px`;
  }
}
